import { render, staticRenderFns } from "./BaseLog.vue?vue&type=template&id=74023228"
import script from "./BaseLog.vue?vue&type=script&lang=js"
export * from "./BaseLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports